import { isServerSide } from "@gazebo/nextjs/utils";
import { useCallback, useLayoutEffect, useState } from "react";

const xy = (x: number, y: number) => ({ x, y })

export const useWindowLayout = () => {
  const [scrolls, setScrolls] = useState(
    isServerSide() ? xy(1, 1) : xy(window.scrollX, window.scrollY)
  );
  const [sizes, setSizes] = useState(
    isServerSide() ? xy(1, 1) : xy(window.innerWidth, window.innerHeight)
  );

  const onLayout = useCallback(() => {
    setScrolls(xy(window.scrollX, window.scrollY));
    setSizes(xy(window.innerWidth, window.innerHeight));
  }, [setScrolls, setSizes]);

  useLayoutEffect(() => {
    window.addEventListener("resize", onLayout);
    return () => window.removeEventListener("resize", onLayout);
  }, [onLayout]);

  return { scrolls, sizes };
};
